import exceljs from "exceljs";
import moment from "moment";
import { saveAs } from "file-saver";
import Helper from "../plugins/Helper/Helper"
import i18n from '@/plugins/vue-i18n';;
export class ExportSettingTask {
  constructor() {
    // excel file type
  }
  static async saveFile(workbook, fileName) {
    const buffer = await workbook.xlsx.writeBuffer();
    const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    const fileExtension = ".xlsx";
    const blob = new Blob([buffer], { type: fileType });
    return saveAs(blob, fileName + fileExtension);
  }


  static async exportSettingTaskByMarket(items){
    const workbook = new exceljs.Workbook();
    const worksheet = workbook.addWorksheet("sheet1");
    worksheet.columns = [
      {
        header: i18n.t('area.area_name'),
        key: 1,
        width: 30,
        style: {
          alignment: {
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('market.action'),
        key: 2,
        width: 30,
        style: {
          alignment: {
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('payment.original_list'),
        key: 3,
        width: 30,
        style: {
          alignment: {
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('payment.new_list'),
        key: 4,
        width: 20,
        style: {
          alignment: {
            horizontal: "right",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('payment.original_price'),
        key: 5,
        width: 20,
        style: {
          alignment: {
            horizontal: "right",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('payment.new_price'),
        key: 6,
        width: 20,
        style: {
          alignment: {
            horizontal: "right",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('payment.original_discount'),
        key: 7,
        width: 20,
        style: {
          alignment: {
            horizontal: "right",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('payment.new_discount'),
        key: 8,
        width: 20,
        style: {
          alignment: {
            horizontal: "right",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('income.difference'),
        key: 9,
        width: 20,
        style: {
          alignment: {
            horizontal: "right",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('payment.currency'),
        key: 10,
        width: 20,
        style: {
          alignment: {
            horizontal: "right",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('payment.original_method'),
        key: 11,
        width: 20,
        style: {
          alignment: {
            horizontal: "right",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('payment.new_method'),
        key: 12,
        width: 20,
        style: {
          alignment: {
            horizontal: "right",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('created_by'),
        key: 13,
        width: 20,
        style: {
          alignment: {
            horizontal: "right",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('created_at'),
        key: 14,
        width: 20,
        style: {
          alignment: {
            horizontal: "right",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('change_status_by'),
        key: 15,
        width: 20,
        style: {
          alignment: {
            horizontal: "right",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('change_status_at'),
        key: 16,
        width: 20,
        style: {
          alignment: {
            horizontal: "right",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('status'),
        key: 17,
        width: 20,
        style: {
          alignment: {
            horizontal: "right",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('note'),
        key: 18,
        width: 20,
        style: {
          alignment: {
            horizontal: "right",
            vertical: "center"
          }
        }
      },
    ]

    for(let item of items){
      let documentId;
      if(item.invoice) documentId = item.invoice.documentId
      if(item.receipt) documentId = item.receipt.documentId

      worksheet.addRow({
        1: item.area.name,
        2: `${item.actionString} (${item.typeName})`,
        3: item.previousAccountingProduct ,
        4: item.currentAccountingProduct ,
        5: item.previousPrice|| 0,
        6: item.currentPrice || 0,
        7: `${item.previousOriginalDiscount || 0}${item.previousDiscountType == 2 ? '%' : ''}`,
        8: `${item.currentOriginalDiscount || 0}${item.currentDiscountType == 2 ? '%' : ''}`,
        9: item.diffPrice.text ,
        10: Helper.currencyThEn(item.currencyCode),
        11: item.previousType ,
        12: item.currentType ,
        13: item.createdByFullName ,
        14: item.createdAt ? new Date(moment(item.createdAt).format("YYYY-MM-DD")) : '-',
        15: item.updatedByFullName ,
        16: item.updatedAt ? new Date(moment(item.updatedAt).format("YYYY-MM-DD")) : '-',
        17: item.statusString ,
        18: item.description ,
      })

      worksheet.lastRow.getCell(17).alignment = { horizontal: "left", vertical: "center" }
    }

    return this.saveFile(workbook, `market-setting-task-${moment(new Date()).format("DDMMYYYY")}`);
  }


}